import { renderDrawerHeader } from '../../Drawer/DrawerHeader';

/**
 * Renders the final JSX of NavDrawerHeader.
 */
export const renderNavDrawerHeader = renderDrawerHeader;
